/* eslint-disable react-hooks/exhaustive-deps */
import { debug } from 'console'
import React, { useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import PhoneInput from 'react-phone-input-2'
import { KTSVG } from '../../../_metronic/helpers'
import { GetDistrictList, GetQuarterList } from '../../modules/api/adress/AdressApiCall'
import { AddNewCustomer, GetInfluencerDetails } from '../../modules/api/_requests'
import { RegisterModel } from '../../types'
import AddressInformations from './components/AddressInformations'
import PersonalInformations from './components/PersonalInformations'
import Cities from '../../modules/api/adress/Cities.json'

const RegisterPage: React.FC = () => {

  const [name, setName] = useState<string>()
  const [surname, setSurname] = useState<string>()
  const [mobilePhoneNumber, setMobilePhoneNumber] = useState<string>()
  const [selectedCity, setCity] = useState<string>()
  const [district, setDistrict] = useState<string>()
  const [quarter, setQuarter] = useState<string>()
  const [avenueName, setAvenueName] = useState<string>('')
  const [streetName, setStreetName] = useState<string>('')
  const [buildingName, setBuildingName] = useState<string>('')

  const [alertMessage, setAlertMessage] = useState<string | undefined>(undefined)
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false)
  const [searchButtonDisabled, setSearchButtonDisabled] = useState<boolean>(false)

  const [influencerDetails, setInfluencerDetails] = useState<any>()

  const [modal, setModal] = useState<boolean>(false)

  const [clear, setClear] = useState<boolean>(false)

  var model: RegisterModel = {
    Name: undefined,
    Surname: undefined,
    MobilePhoneNumber: undefined,
    City: undefined,
    District: undefined,
    Quarter: undefined,
    AvenueName: undefined,
    StreetName: undefined,
    BuildingName: undefined,
    SalesPersonUserName: localStorage.getItem('salesPersonUsername')
  };

  const [countryDisabled, setCountryDisabled] = useState<boolean>(true)
  const [countries, setCountries] = useState<any>([])
  const [hoods, setHoods] = useState<any>()
  const [hoodDisabled, setHoddDisabled] = useState<boolean>(true)


  const [paramCity, setParamCity] = useState<string | undefined>(undefined)
  const [paramDistrict, setParamDistrict] = useState<string | undefined>(undefined)
  const [paramQuarter, setParamQuarter] = useState<string | undefined>(undefined)

  useEffect(() => {
    if (selectedCity) {
      setHoods([])


      setDistrict(undefined)
      setParamDistrict(undefined)
      setParamQuarter(undefined)
      setCountries([])
      setQuarter(undefined)

      GetDistrictList(selectedCity.split('+')[0], setCountries)
      setCountryDisabled(false)
    }
  }, [selectedCity])

  useEffect(() => {
    console.log("64");
    console.log("64", district);
    console.log("64");

    setQuarter(undefined)
    // setParamQuarter(undefined)
    setHoods([])
    // setQuarter(undefined);
    if (district) {
      setHoods([])
      GetQuarterList(district.split('+')[0], setHoods)
      setHoddDisabled(false)
    }
  }, [district])


  const loadModel = () => {
    model.Name = name
    model.Surname = surname
    model.MobilePhoneNumber = mobilePhoneNumber && mobilePhoneNumber.slice(1)
    model.City = (selectedCity ? (selectedCity.includes('+') ? selectedCity.split('+')[1] : selectedCity) : paramCity);
    model.District = (district ? (district.includes('+') ? district.split('+')[1] : district) : paramDistrict);
    model.Quarter = quarter ?? paramQuarter
    model.AvenueName = avenueName
    model.StreetName = streetName
    model.BuildingName = buildingName
  }

  useEffect(() => {
    if (name && surname && mobilePhoneNumber && (selectedCity || paramCity) && (district || paramDistrict) && (quarter || paramQuarter)) {
      model.Name = name
      model.Surname = surname
      model.MobilePhoneNumber = mobilePhoneNumber.slice(1)
      model.City = (selectedCity ? (selectedCity.includes('+') ? selectedCity.split('+')[1] : selectedCity) : paramCity);
      model.District = (district ? (district.includes('+') ? district.split('+')[1] : district) : paramDistrict);
      model.Quarter = quarter ?? paramQuarter
      model.AvenueName = avenueName
      model.StreetName = streetName
      model.BuildingName = buildingName
    }
  }, [name, surname, mobilePhoneNumber, selectedCity, district, quarter, avenueName, streetName, buildingName])

  const handleSubmit = async () => {
    setClear(false)
    if (name && surname && mobilePhoneNumber && (selectedCity || paramCity) && (district || paramDistrict) && (quarter || paramQuarter)) {
      loadModel();
      setAlertMessage(undefined)
      setButtonDisabled(true)

      var response = await GetInfluencerDetails("0", setInfluencerDetails, model.MobilePhoneNumber)

      if (response.status) {
        // setModal(true)
        setButtonDisabled(false)
        loadModel();
        AddNewCustomer(model);
      } else {
        setButtonDisabled(false)
        AddNewCustomer(model);
      }
    }
    else {
      setAlertMessage('Lütfen gerekli alanları doldurun')
    }
  }

  const kaydet = () => {
    debugger;
    loadModel();
    debugger;
    AddNewCustomer(model);
  }


  const searchUser = async () => {
    try {
      setSearchButtonDisabled(true);

      var response = await GetInfluencerDetails("0", setInfluencerDetails, mobilePhoneNumber && mobilePhoneNumber.slice(1));

      console.log("reps", response);

      if (response.status) {
        setSearchButtonDisabled(false);
        let entity = JSON.parse(response.detail as string);
        console.log("1111 ", entity);

        setName(entity.Name);
        setSurname(entity.SurName);

        setParamCity(entity.City);
        setParamDistrict(entity.District);
        setParamQuarter(entity.Quarter);

        setCity(undefined);
        setDistrict(undefined);
        setQuarter(undefined);


        setStreetName(entity.StreetName);
        setAvenueName(entity.AvenueName);
        setBuildingName(entity.HouseNo);
      }
    } catch (err) {
      setSearchButtonDisabled(false);
    } finally {
      setSearchButtonDisabled(false);
    }


  }

  return (
    <>
      {modal && <div className='sms-modal-card'>
        <div className='card card-content' style={{ display: "flex", flexWrap: "nowrap", flexDirection: "column", justifyContent: "space-around", height: 200 }}>
          <div style={{ textAlign: 'center' }}>
            <h1>Dikkat</h1>
            <span>Kullanıcı kaydı bulunuyor, yinede kaydedilsin mi?</span>
          </div>
          <div>
            <button className='btn btn-success' onClick={() => kaydet()}>
              Kaydet
            </button>
            <button className='btn btn-danger ml-2' style={{ marginLeft: 2 }} onClick={() => window.location.replace(window.location.href)}>
              Kapat
            </button>
          </div>
        </div>
      </div>
      }

      <div className='card form-group'>

        <h3 className='card-header d-flex align-items-center'>Influencer Kayıt</h3>

        <div className='card-body'>


          <div className="d-flex align-items-center mb-4">
            <KTSVG path='/media/icons/duotune/communication/com013.svg' className='svg-icon-dark svg-icon-1 ' />
            <span className='text-gray ms-2 fs-3 fw-bold'>Kişisel Bilgiler</span>
          </div>

          {/* <PersonalInformations setName={setName} setSurname={setSurname} setMobilePhoneNumber={setMobilePhoneNumber} /> */}
          <div className="row">

            <div className="col-md-4 mb-4">
              <PhoneInput
                country={'tr'}
                specialLabel='Telefon Numarası *'
                inputClass='form-control form-control-solid bg-light'
                enableAreaCodes={false}
                prefix='+'
                onChange={(e) => { setMobilePhoneNumber(e) }}
              />
            </div>
            <div className="col-md-4 mb-4">
              <div className="special-label">&nbsp;</div>
              <button className='btn btn-primary' onClick={searchUser} disabled={searchButtonDisabled}>
                {!searchButtonDisabled ? "Ara" : "Lütfen Bekleyiniz"}
              </button>
            </div>
            <div className="col-md-4 mb-4">
            </div>

            <br />

            <div className="col-md-4 mb-4">
              <label htmlFor="name" >İsim <span className='text-danger'>*</span></label>
              <input
                type="text"
                id='name'
                className='form-control form-control-solid'
                value={name}
                onChange={(e) => { setName(e.target.value) }}
                required
              />
            </div>
            <div className="col-md-4 mb-4">
              <label htmlFor="surname" >Soy İsim <span className='text-danger'>*</span></label>
              <input
                type="text"
                id='surname'
                value={surname}
                className='form-control form-control-solid'
                onChange={(e) => { setSurname(e.target.value) }}
                required
              />
            </div>

          </div>

          <div className="d-flex align-items-center mb-4 mt-10">
            <KTSVG path='/media/icons/duotune/maps/map008.svg' className='svg-icon-dark svg-icon-1 ' />
            <span className='text-gray ms-2 fs-3 fw-bold'>Adres Bilgileri</span>
          </div>

          <>
            <div className='row'>
              <div className="col-md-6 mb-4">
                <label htmlFor="city">Şehir <span className='text-danger'>*</span></label>
                <select
                  name="city"
                  className='form-select form-select-solid'
                  id="city"
                  onChange={(e) => setCity(e.target.value)}
                  defaultValue={undefined}
                  required
                >
                  {paramCity == undefined && <option value={undefined} selected>Lütfen Şehir Seçiniz</option>}
                  {paramCity != undefined && <option value={undefined} selected>{paramCity}</option>}
                  {Cities.map((city: any, index: number) =>
                    <option
                      key={index}
                      value={city.id + '+' + city.name}
                      selected={city.name === selectedCity?.split("+")[1]}
                    >{city.name}</option>
                  )}
                </select>
              </div>

              <div className='col-md-6 mb-4'>
                <label htmlFor="country">İlçe <span className='text-danger'>*</span></label>
                <select
                  name="country"
                  className='form-select form-select-solid'
                  id="city"
                  disabled={countryDisabled}
                  onChange={(e) => setDistrict(e.target.value)}
                  defaultValue={undefined}
                  required
                >
                  {paramDistrict == undefined && (district == undefined || district?.includes("+"))
                    && selectedCity && selectedCity != ""
                    && <option value={undefined} selected={true}>Lütfen İlçe Seçiniz</option>
                  }
                  {countries && countries.map((country: any, index: number) =>
                    <option
                      key={index}
                      value={country.DistrictId + '+' + country.Name}

                    >{country.Name}</option>

                  )}
                  {(paramDistrict != undefined) && <option selected={true}>{paramDistrict}</option>}
                </select>
              </div>
            </div>

            <div className="row ">

              <div className="col-md-6 mb-4">
                <label htmlFor="hood">Mahalle <span className='text-danger'>*</span></label>
                <select
                  name="hood"
                  className='form-select form-select-solid'
                  id="hood"
                  onChange={(e) => setQuarter(e.target.value)}
                  disabled={hoodDisabled}
                  defaultValue={undefined}
                  required
                >
                  {paramQuarter == undefined && (quarter?.includes("+") || quarter == undefined) && district && district != "" && <option value={undefined} selected={true}>Lütfen Mahalle Seçiniz</option>}
                  {hoods && hoods.map((hood: any, index: number) =>
                    <option
                      key={index}
                      value={hood.Name}
                    >{hood.Name}</option>
                  )}
                  {paramQuarter && <option selected={true}>{paramQuarter}</option>}
                </select>
              </div>

              <div className="col-md-6 mb-4">
                <label htmlFor="avenue" >Cadde </label>
                <input
                  type="text"
                  id='avenue'
                  className='form-control form-control-solid'
                  value={avenueName}
                  onChange={(e) => { setAvenueName(e.target.value) }}
                />
              </div>
            </div>

            <div className="row">

              <div className="col-md-6 mb-4">
                <label htmlFor="street" >Sokak </label>
                <input
                  type="text"
                  id='strees'
                  className='form-control form-control-solid'
                  value={streetName}
                  onChange={(e) => { setStreetName(e.target.value) }}
                />
              </div>

              <div className="col-md-6 mb-4">
                <label htmlFor="apartment" >Bina No </label>
                <input
                  type="number"
                  id='apartment'
                  className='form-control form-control-solid'
                  value={buildingName}
                  onChange={(e) => { setBuildingName(e.target.value) }}
                />
              </div>
            </div>
          </>


          {/* <AddressInformations
            setCity={setCity}
            setDistrict={setDistrict}
            setQuarter={setQuarter}
            setAvenueName={setAvenueName}
            setStreetName={setStreetName}
            setBuildingName={setBuildingName}
            city={city}
            district={district}
            clearParam={clear} /> */}

          <hr />

          <div className="row mt-3 p-3 col-md-3 d-flex justify-content-center" >
            <button onClick={() => handleSubmit()} value={'Kaydet'} className='btn btn-success' disabled={buttonDisabled}>
              Kaydet
            </button>
          </div>
          {alertMessage && <div className='row'>
            <div className="col-12 d-flex justify-content-center">
              <div className="alert alert-warning w-100 text-center" role="alert">
                {alertMessage}
              </div>
            </div>
          </div>}

        </div>
      </div>
    </>
  )
}

export { RegisterPage }
